// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentGetBestEnrollmentDefaultResponse {
    static getAttributeTypeMap() {
        return EnrollmentGetBestEnrollmentDefaultResponse.attributeTypeMap;
    }
}
EnrollmentGetBestEnrollmentDefaultResponse.discriminator = undefined;
EnrollmentGetBestEnrollmentDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "EnrollmentModel"
    }
];
//# sourceMappingURL=enrollmentGetBestEnrollmentDefaultResponse.js.map